import {useEffect} from "react";
import {batch, useSignal} from "@preact/signals-react";
import {useAppToast} from "@ui-seeker/app";
import {postSubmit} from "@ui-seeker/utils";

import {commonFiltersValue, isLoadingCommonFilters, isSystemBusy} from "@signals";
import { useStockChangesRoleConfig } from "../../@hooks";
import { StockChangesStockEvolutionFilters, StockChangesPriceEvolutionFilters, StockChangesSubmittedFilters } from "../../@signals";


export default function useStockChangesSearch() {
	const { showToast } = useAppToast()
    const { urlApi } = useStockChangesRoleConfig()

    const stockChangesData = useSignal([])
	const stockChangesIsEmpty = useSignal(false)

    useEffect(() => {
		if (isLoadingCommonFilters.value) batch(() => {
			stockChangesIsEmpty.value = false
			StockChangesStockEvolutionFilters.value = {}
			StockChangesPriceEvolutionFilters.value = {}
			postSubmit(urlApi, { ...commonFiltersValue.value }).then(res => {
				StockChangesSubmittedFilters.value = commonFiltersValue.peek()
				if (!res?.length) stockChangesIsEmpty.value = true
				stockChangesData.value = res
			}).catch(() => isSystemBusy.value = true
			).finally(() => {
				isLoadingCommonFilters.value = false
			})
		})
	}, [isLoadingCommonFilters.value]);


	return {
		stockChangesData: stockChangesData.value,
		stockChangesIsEmpty: stockChangesIsEmpty.value
	}
}